<div class="calendarpanel">
  <div class="calendar">
    @if (false) {
      <div class="week">
        <button (click)="clickPrevWeek()" [disabled]="ss.session.day.day === 1 && ss.session.day.month === 1" class="weekctrl"
                mat-button>
          <mat-icon>arrow_left</mat-icon>
        </button>
        @for (day of ss.session.week; track $index) {
          <button (click)="clickWeekDay(day)" [class]="weekClass(day)"
                  mat-flat-button>
            @if (day.times.length > 0) {
              [
            }
            {{ ss.calendar.weekDayNameShort(day) }} {{ day.day }}
            @if (day.times.length > 0) {
              ]
            }
          </button>
        }
        <button (click)="clickNextWeek()" class="weekctrl" mat-flat-button>
          <mat-icon>arrow_right</mat-icon>
        </button>
      </div>
    }
    <cal-month [month]="ss.session.day.month" [navigation]="true" [update]="triggerUpdate"
               [year]="ss.session.day.year"></cal-month>
  </div>
  <div class="timepanel">
    <div class="title" i18n>
      <div>Zeiten für {{ ss.session.day.dateString }}</div>
      <button [class]="classForDaytype"
              [matMenuTriggerFor]="menu"
              aria-label="Tagesart"
              i18n-aria-label
              mat-flat-button>
        {{ ss.session.day.nameForType(ss.session.day.type) }}
      </button>
    </div>
    <mat-menu #menu="matMenu" class="daytype-menu">
      @for (entry of dayTypeList; track $index) {
        @if (entry.id !== ss.session.day.type) {
          <button
            (click)="clickDayType(entry.id)"
            [class]="typeClass(entry.id)"
            mat-flat-button>{{ entry.label }}
          </button>
        }
      }
    </mat-menu>
    <div class="times">
      @for (time of ss.session.day.times; track $index; let idx = $index) {
        <mat-card (click)="toggleTime(idx)"
                  [class]="timeClass(idx, time)">
          <mat-card-header>
            <mat-card-title>{{ time.typeForDisplay }}</mat-card-title>
            @if (idx === dataIdx) {
              <button (click)="deleteTime($event, idx)" mat-icon-button>
                <mat-icon>delete</mat-icon>
              </button>
            }
            @if (idx !== dataIdx) {
              <button mat-icon-button></button>
            }
          </mat-card-header>
          <div class="content">
            <!-- (ngModelChange)="ss.saveSession()"  -->
            <input (blur)="ss.saveSession()" [(ngModel)]="time.fromValue" type="time">
            <div i18n>bis</div>
            <input (blur)="ss.saveSession()" [(ngModel)]="time.toValue" type="time">
          </div>
          @if (time.type === 0 && (idx === dataIdx || (time.projects?.length > 0))) {
            <div class="projhead">
              <div class="line1">&nbsp;</div>
              <div class="text">Projekte</div>
              <div class="line2">&nbsp;</div>
            </div>
          }
          @if (time.projects?.length > 0) {
            <table cellpadding="0" cellspacing="0" class="project">
              @for (proj of time.projects; let projIdx = $index; track projIdx) {
                <tr>
                  <td>{{ proj.name }}</td>
                  <td>
                    {{ proj.durationDisplay }}
                  </td>
                  <td>{{ proj.info }}</td>
                  @if (idx === dataIdx) {
                    <td>
                      <button (click)="editProject($event, time, projIdx)" mat-icon-button>
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button (click)="deleteProject($event, time, projIdx)" mat-icon-button>
                        <mat-icon>delete</mat-icon>
                      </button>
                    </td>
                  }
                </tr>
              }
            </table>
          }
          <div class="content">
            @if (time.type === 0 && idx === dataIdx && time.end != null) {
              <button (click)="distributeTime($event, time)" mat-icon-button>
                <mat-icon>add</mat-icon>
              </button>
            }
          </div>
        </mat-card>
      }
    </div>
  </div>
  <div class="ctrls">
    <button (click)="clickRefresh()" mat-flat-button>
      <mat-icon>refresh</mat-icon>
    </button>
    <button (click)="clickExport()" mat-flat-button>
      <mat-icon>save</mat-icon>
    </button>
    <button (click)="clickImport()" mat-flat-button>
      <mat-icon>text_snippet</mat-icon>
    </button>
    <input (change)="handleImport($event)" accept="text/json" id="importData" type="file">
  </div>
</div>
<div class="controls">
  <button (click)="clickPlay($event)" [class]="weekClass(ss.session.day)" mat-flat-button>
    {{ playData.text }}
    <mat-icon>{{ playData.icon }}</mat-icon>
  </button>

  <button (click)="clickStop($event)" [class]="weekClass(ss.session.day)" [disabled]="data==null" mat-flat-button>
    <ng-container i18n>Gehen</ng-container>
    <mat-icon>home</mat-icon>
  </button>
</div>
